<!-- 会员详情 -->
<template>
<div class="memberDetails">
    <div class="userInfoBox">
        <div class="userInfo">
            <img :src="memberDetails.islogin ? (user.logourl ? user.logourl : require('@/common/images/memberDetails/default_head_picture.png')) : require('@/common/images/memberDetails/default_head_picture.png')" class="headPicture" alt="">
            <div class="name">{{ user.isLogin ? user.name : '您好' }}</div>
            <div class="tips" v-if="!user.isLogin">登录后查看会员状态</div>
            <div class="tips" v-else>
                <span v-if="memberDetails.zjmemtype === 0 && memberDetails.status === 0">暂未开通会员</span>
                <span v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1">蓝鲸会PLUS会员</span>
                <span v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">蓝鲸会年卡会员</span>
                <span class="renew" v-if="memberDetails.status === 99">{{memberDetails.zjmemtype === 1 ? '蓝鲸会PLUS卡' : '蓝鲸会年卡'}}已过期，续费会员></span>
            </div>
            <div class="expiredate" v-if="memberDetails.status === 1">有效期至 {{memberDetails.expiredate}}</div>
        </div>
    </div>
    <div class="memberDetailsWrap">
        <div class="moduleTitle">蓝鲸会员</div>
        <div class="memberType">
            <div class="memberCard yearCard">
                <div class="cardName">蓝鲸会年卡</div>
                <div class="tips" v-if="!memberDetails.islogin || memberDetails.status === 99 || memberDetails.status === 0 || memberDetails.zjmemtype === 1">开通会员，即刻享受更多权益</div>
                <div class="tips" v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">有效期至 {{memberDetails.expiredate}}</div>
                <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(2)">立即开通</div>
                <div class="btn" v-if=" memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">升级年卡</div>
                <div class="btn" v-if=" memberDetails.zjmemtype === 2 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">马上续费</div>
            </div>
            <div class="memberCard plusCard">
                <div class="cardName">蓝鲸会PLUS卡</div>
                <div class="tips" v-if="!memberDetails.islogin || memberDetails.status === 99 || memberDetails.status === 0">开通会员，即刻享受更多权益</div>
                <div class="tips" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1">有效期至 {{memberDetails.expiredate}}</div>
                <div class="tips" v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">当前已享有会员最高权益</div>
                <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(1)">立即开通</div>
                <div class="btn" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(1)">马上续费</div>
            </div>
        </div>
        <!-- <div class="memberCard">
            <div class="dataCount courseCount">会员课程 {{ courseTotal }} 个</div>
            <div class="dataCount reportCount">会员报告 {{ reportTotal }} 个</div>
        </div> -->
        <div class="moduleTitle">会员介绍</div>
        <div class="memberIntroduce">
            <div class="title">鲸融网蓝鲸会</div>
            <div class="info">鲸融网，以创新、创投、创业、创富为核心关键词，为投行、券商、律所、VC/PE等行业从业者、企业创始人、泛金融从业者以及新型企投家，提供专业的投资与创业学习成长内容。</div>
            <div class="introduceBox">
                <div class="introduceItem">
                    <img :src="require('@/common/images/memberDetails/introduce_item_icon1.png')" class="introduceItemIcon" alt="">
                    <div class="itemIntro">
                        <div>最前沿的创投知识</div>
                        <div>开阔眼界放大格局</div>
                    </div>
                    <div class="label">创新</div>
                </div>
                <div class="introduceItem">
                    <img :src="require('@/common/images/memberDetails/introduce_item_icon2.png')" class="introduceItemIcon" alt="">
                    <div class="itemIntro">
                        <div>最专业的投资干货</div>
                        <div>掌握投资底层逻辑</div>
                    </div>
                    <div class="label">创投</div>
                </div>
                <div class="introduceItem">
                    <img :src="require('@/common/images/memberDetails/introduce_item_icon3.png')" class="introduceItemIcon" alt="">
                    <div class="itemIntro">
                        <div>最实战的创业技能</div>
                        <div>从零到一不走弯路</div>
                    </div>
                    <div class="label">创业</div>
                </div>
                <div class="introduceItem">
                    <img :src="require('@/common/images/memberDetails/introduce_item_icon4.png')" class="introduceItemIcon" alt="">
                    <div class="itemIntro">
                        <div>最实操的财富密码</div>
                        <div>提升风险抵御能力</div>
                    </div>
                    <div class="label">创富</div>
                </div>
            </div>
            <div class="title">蓝鲸会四维一体服务</div>
            <div class="fourServe">
                <div class="serveItem">
                    <div class="itemTitle">三大专业板块内容</div>
                    <div class="itemContent">投资、创业、理财，三大系统专业板块内容，陪伴创投每一步</div>
                </div>
                <div class="serveItem">
                    <div class="itemTitle">前沿热点随时跟进</div>
                    <div class="itemContent">持续上线最新课程，随时随地跟进学习最新最热的前沿赛道</div>
                </div>
                <div class="serveItem">
                    <div class="itemTitle">专享会员互动社群</div>
                    <div class="itemContent">随时随地与各行业精英沟通学习，交流观点看法，扩展认知边界</div>
                </div>
                <div class="serveItem">
                    <div class="itemTitle">顶级投资人言传身教</div>
                    <div class="itemContent">头部机构顶级投资人，结合自身投资经验及行业趋势，分享实战经验方法</div>
                </div>
                <img :src="require('@/common/images/memberDetails/four_icon.png')" class="fourIcon" alt="">
            </div>
        </div>
        <div class="moduleTitle">会员权益</div>
        <div class="memberPower">
            <div class="tips">诚邀国内头部机构行业精英担任导师，共同打磨课程，将投资逻辑、已验证的投资决策和盘托出，为你呈现既有深度又有广度的高价值内容。</div>
            <div class="typeTable">
                <div class="row row1">
                    <div class="type">类别</div>
                    <div class="yearCard">蓝鲸会年卡</div>
                    <div class="plusCard">蓝鲸会PLUS卡</div>
                </div>
                <div class="row row2">
                    <div class="price">价格</div>
                    <div class="yearprice">{{memberDetails.yearprice}}元<span class="unit">/年</span></div>
                    <div class="plusprice">{{memberDetails.plusprice}}元<span class="unit">/年</span></div>
                </div>
                <div class="row row3">
                    <div class="power">会员权益</div>
                    <div class="yearPower">
                        <div class="powerItemBox">
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue"><span>3000+</span>分钟课程时长免费学</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue"><span>13000+</span>免费行业精品报告</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue"><span>80+</span>业内实战授课老师</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">5*12小时专属客服</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">VIP会员专属活动</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">创投沙龙活动</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">最新研报及部分课程PPT</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">折扣购买其他付费课程</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                                <div class="itemValue">推荐好友加入领取月度资料集</div>
                            </div>
                        </div>
                        <div class="btnBox">
                            <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(2)">立即开通</div>
                            <div class="btn" v-if=" memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">升级年卡</div>
                            <div class="btn" v-if=" memberDetails.zjmemtype === 2 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">马上续费</div>
                        </div>
                    </div>
                    <div class="plusPower">
                        <div class="powerItemBox">
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue"><span>1000+</span>免费行业精品报告</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue">5*12小时专属客服</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue">VIP会员专属活动</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue">最新研报及部分课程PPT</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue">折扣购买其他付费课程</div>
                            </div>
                            <div class="powerItem">
                                <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                                <div class="itemValue">推荐好友加入领取月度资料集</div>
                            </div>
                        </div>
                        <div class="btnBox">
                            <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(1)">立即开通</div>
                            <div class="btn" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(1)">马上续费</div>
                            <div class="btn disabled" v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">马上续费</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="moduleTitle">常见问题</div>
        <div class="questionItemBox">
            <div class="questionItem">
                <div class="question">
                    <div class="label">问</div>
                    <div class="value">购买会员后可以学习哪些内容和下载哪些资料？</div>
                </div>
                <div class="answer">
                    <div class="label">答</div>
                    <div class="value">蓝鲸会员在鲸融网，可无限次学习鲸融网自研课程和下载会员资料包。</div>
                </div>
            </div>
            <div class="questionItem">
                <div class="question">
                    <div class="label">问</div>
                    <div class="value">在哪学习，学习形式是怎样？</div>
                </div>
                <div class="answer">
                    <div class="label">答</div>
                    <div class="value">开通账号后在鲸融网、鲸融网APP、订阅号​学习。</div>
                </div>
            </div>
            <div class="questionItem">
                <div class="question">
                    <div class="label">问</div>
                    <div class="value">课程和资料会迭代更新吗？</div>
                </div>
                <div class="answer">
                    <div class="label">答</div>
                    <div class="value">课程和资料包全年持续更新，请留意会员群消息。</div>
                </div>
            </div>
            <div class="questionItem">
                <div class="question">
                    <div class="label">问</div>
                    <div class="value">可以开具发票报销吗？</div>
                </div>
                <div class="answer">
                    <div class="label">答</div>
                    <div class="value">购买蓝鲸会员及鲸融网课程如果需要开具发票，请联系客服索要正规发票。</div>
                </div>
            </div>
            <div class="questionItem">
                <div class="question">
                    <div class="label">问</div>
                    <div class="value">购买会员/课程后可以退款吗？</div>
                </div>
                <div class="answer">
                    <div class="label">答</div>
                    <div class="value">会员/课程服务为虚拟服务，一旦开启，课程权益即刻开放，所以不支持中途退款，请谨慎选择！</div>
                </div>
            </div>
        </div>
        <div class="moduleTitle">联系我们</div>
        <div class="linkUs">
            <div>咨询热线：0755-86393160 13066904312（微信同号）</div>
            <div>联系邮箱：info@capwhale.com</div>
            <div>会员管理秘书：zijing361</div>
            <div>公司地址：深圳市南山区​粤兴二道6号武汉大学深圳产学研大楼A601-I</div>
        </div>
        <div class="memberPrivilege" v-if="courseTotal">
            <div class="titleMore">
                <div class="title">会员课程（{{courseTotal}}）</div>
                <div class="more" @click="handleGoMoreCourse">更多></div>
            </div>
            <div class="itemBox">
                <div class="item" @click="handleGoCourseDetails(item)" v-for="(item, index) in courseList" :key="index">
                    <img :src="item.coverurl" class="coverurl" alt="">
                    <div class="subject">{{ item.subject }}</div>
                </div>
            </div>
        </div>
        <div class="memberPrivilege" v-if="reportTotal">
            <div class="titleMore">
                <div class="title">会员报告（{{reportTotal}}）</div>
                <div class="more" @click="handleGoMoreReport">更多></div>
            </div>
            <div class="itemBox">
                <div class="item" @click="handleGoReportDetails(item)" v-for="(item, index) in reportList" :key="index">
                    <img :src="item.coverurl" class="coverurl" alt="">
                    <div class="subject">{{ item.subject }}</div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog class="openMemberSuccessDialog" :visible.sync="showOpenMemberSuccess" :show-close="false" width="908px">
        <div class="openSuccessTips">
            <div class="tips">
                <div>恭喜您</div>
                <div>成功开通蓝鲸会员{{ ordertype === 62 ? 'PLUS卡' : '年卡' }}</div>
            </div>
            <div class="expiredate">有效期至 {{ expiredate }}</div>
            <div class="closeBtn" @click="showOpenMemberSuccess = false">好的，知道了</div>
        </div> 
    </el-dialog>
</div>
</template>

<script>
import {queryCustomerFeeInfo, uploadCustomerFeeOrder, queryCustomerFeeOrderPayResult} from '@/api/memberDetails.js'
import {getCustomerInfo} from '@/api/api.js'
import {getSearchResult} from '@/api/reportApi.js'
import {mapGetters, mapActions} from 'vuex'
export default {
    data() {
        return {
            memberDetails: {},
            courseList: [],
            courseTotal: 0,
            reportList: [],
            reportTotal: 0,
            showOpenMemberSuccess: false,
            expiredate: '',
            ordertype: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(this.domainInfo.isMobile){
            if (this.$route.query.orderno && this.$route.query.rid && this.$route.query.result && this.$route.query.sign) {
                this.$router.push({
                    name: 'MMemberDetails',
                    query: {
                        chid: this.$route.query.chid ? this.$route.query.chid : ''
                    },
                    params: {
                        orderno: this.$route.query.orderno,
                        rid: this.$route.query.rid,
                        result: this.$route.query.result,
                        sign: this.$route.query.sign
                    }
                })
            } else {
                this.$router.push({
                    name: 'MMemberDetails',
                    query: {
                        chid: this.$route.query.chid ? this.$route.query.chid : ''
                    }
                })
            }
        } else {
            if (this.$route.query.orderno && this.$route.query.rid && this.$route.query.result && this.$route.query.sign) {
                this.$router.push({
                    name: 'MemberDetails',
                    replace: true,
                    params: {
                        orderno: this.$route.query.orderno,
                        rid: this.$route.query.rid,
                        result: this.$route.query.result,
                        sign: this.$route.query.sign
                    }
                })
            }
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        if (this.$route.params.orderno && this.$route.params.rid && this.$route.params.result && this.$route.params.sign) {
            this.handleQueryCustomerFeeOrderPayResult()
        } else {
            this.handleQueryCustomerFeeInfo()
        }
        this.handleGetSearchResult({
            key: '',
            catecode: '',
            catecode2: '',
            coursetype: '',
            feetype: '',
            kmctype: 7,
            page: 1,
            pageSize: 4,
            couponinnerid: '',
            voucherdistype: '',
            zjmemtype: 1
        })
        this.handleGetSearchResult({
            key: '',
            catecode: '',
            catecode2: '',
            reportyear: '',
            feetype: '',
            hostid: '',
            kmctype: 2,
            page: 1,
            pageSize: 4,
            zjmemtype: 1
        })
    },
    methods: {
        handleQueryCustomerFeeOrderPayResult() {
            let params = {
                orderno: this.$route.params.orderno,
                result: this.$route.params.result,
                rid: this.$route.params.rid,
                sign: this.$route.params.sign,
                ispaysuccess: 1
            }
            this.setLoading(true)
            queryCustomerFeeOrderPayResult({
                data: params,
                success: res => {
                    this.setLoading(false)
                    // res.data.status = 30
                    this.expiredate = res.data.orderexpiredate
                    this.ordertype = res.data.ordertype
                    if (res.data.status === 30) {
                        if (res.data.logintoken) {
                            let user = {
                                loginToken: res.data.logintoken ? res.data.logintoken : ''
                            }
                            window.sessionStorage.setItem('user', JSON.stringify(user))
                            this.setUser(user)
                        }
                        if (this.user.isLogin && res.data.islogin && this.user.loginToken === res.data.logintoken) {
                            this.showOpenMemberSuccess = true
                            this.handleQueryCustomerFeeInfo()
                        } else if (res.data.islogin) {
                            this.setLoading(true)
                            getCustomerInfo({
                                data: {},
                                success: data => {
                                    this.setLoading(false)
                                    let user = {
                                        innerid: data.data.innerid ? data.data.innerid : '',
                                        isperfect: data.data.isperfect ? data.data.isperfect : '',
                                        loginToken: data.data.loginToken ? data.data.loginToken : '',
                                        loginname: data.data.loginname ? data.data.loginname : '',
                                        logourl: data.data.logourl ? data.data.logourl : '',
                                        mobile: data.data.mobile ? data.data.mobile : '',
                                        name: data.data.name ? data.data.name : '',
                                        nickname: data.data.nickname ? data.data.nickname : '',
                                        promoterid: data.data.promoterid ? data.data.promoterid : '',
                                        isLogin: data.data.innerid ? true : false,
                                        zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                                    }
                                    window.sessionStorage.setItem('user', JSON.stringify(user))
                                    this.setUser(user)
                                    this._setCookie('token', user.loginToken)
                                    this.showOpenMemberSuccess = true
                                },
                                error: res => {
                                    this.setLoading(false)
                                    this.$message.error(res.msg)
                                    this.handleQueryCustomerFeeInfo()
                                }
                            })
                        } else {
                            this.handleQueryCustomerFeeInfo()
                        }
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.handleQueryCustomerFeeInfo()
                    // this.$message.error(res.msg)
                }
            })
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        handleQueryCustomerFeeInfo() {
            this.setLoading(true)
            queryCustomerFeeInfo({
                data: {},
                success: res => {
                    this.setLoading(false)
                    // res.data.status = 1
                    // res.data.expiredate = '2024年08月01日'
                    this.memberDetails = res.data
                    if (!this.memberDetails.islogin && this.user.isLogin) {
                        window.sessionStorage.clear()
                        let user = {
                            innerid: '',
                            loginToken: '',
                            loginname: '',
                            logourl: '',
                            mobile: '',
                            name: '',
                            nickname: '',
                            isLogin: false,
                            zjmemtype: 0
                        }
                        this.setUser(user)
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        handleGetSearchResult(params) {
            this.setLoading(true)
            getSearchResult({
                data: params,
                success: res => {
                    this.setLoading(false)
                    if (params.kmctype === 7) {
                        this.courseList = res.data.courselist
                        this.courseTotal = res.data.pageinfo.rowCount
                    } else if (params.kmctype === 2) {
                        this.reportList = res.data.reportlist
                        this.reportTotal = res.data.pageinfo.rowCount
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 去课程详情
        handleGoCourseDetails(item) {
            this.$router.push({name: 'CourseDetails', query: {cid: item.innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        handleGoMoreCourse() {
            this.$router.push({name: 'Search', query: {feetype: '3'}})
        },
        // 去报告详情
        handleGoReportDetails(item) {
            this.$router.push({name: 'ReportDetails', query: {reportid: item.innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        handleGoMoreReport() {
            this.$router.push({name: 'ReportSearch', query: {feetype: '3'}})
        },
        handleUploadCustomerFeeOrder(zjmemtype) {
            if (!this.memberDetails.islogin) {
                this.setLoginPop(true)
            } else {
                let params = {
                    zjmemtype,
                    ordermoney: zjmemtype === 1 ? this.memberDetails.plusprice : this.memberDetails.yearprice,
                    resulturl: location.href
                }
                this.setLoading(true)
                uploadCustomerFeeOrder({
                    data: params,
                    success: res => {
                        this.setLoading(false)
                        window.location.replace(res.data.url)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    watch: {
        user: function(newVal, oldVal) {
            if (newVal != oldVal && newVal.innerid) {
                this.handleQueryCustomerFeeInfo()
            }
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.memberDetails {
    .userInfoBox {
        height: 280px;
        background: url('../../../common/images/memberDetails/userinfo_bg.png') no-repeat;
        background-size: 100% 100%;
        .userInfo {
            width: 1200px;
            height: 280px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            .headPicture {
                width: 120px;
                height: 120px;
                border-radius: 50%;
                margin-bottom: 20px;
            }
            .name {
                font-size: 16px;
                color: #fff;
                line-height: 20px;
                font-weight: bold;
                margin-bottom: 6px;
            }
            .tips {
                font-size: 14px;
                color: #fff;
                line-height: 16px;
                .renew {
                    color: #FFD028;
                    cursor: pointer;
                }
            }
            .expiredate {
                font-size: 14px;
                color: #FFD028;
                line-height: 16px;
                margin-top: 4px;
            }
        }
    }
    .memberDetailsWrap {
        width: 1200px;
        margin: 0 auto 20px;
        .moduleTitle {
            width: 314px;
            height: 50px;
            background: url('../../../common/images/memberDetails/title_bg.png') no-repeat;
            background-size: 100% 100%;
            margin: 40px auto 0;
            text-align: center;
            line-height: 50px;
            font-size: 36px;
            color: #333333;
            font-weight: bold;
        }
        .memberType {
            width: 844px;
            margin: 44px auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .memberCard {
                width: 380px;
                height: 210px;
                padding-top: 56px;
                padding-left: 20px;
                box-sizing: border-box;
                &.yearCard {
                    background: url('../../../common/images/memberDetails/year_member_card.png') no-repeat;
                    background-size: 100% 100%;
                    margin-right: 84px;
                }
                &.plusCard {
                    background: url('../../../common/images/memberDetails/plus_member_card.png') no-repeat;
                    background-size: 100% 100%;
                }
                .cardName {
                    font-size: 26px;
                    font-weight: bold;
                    line-height: 30px;
                    margin-bottom: 4px;
                    color: #fff;
                }
                .tips {
                    color: #fff;
                    font-size: 12px;
                    line-height: 14px;
                    margin-bottom: 20px;
                }
                .btn {
                    width: 110px;
                    height: 28px;
                    color: #fff;
                    border-radius: 100px;
                    text-align: center;
                    line-height: 28px;
                    cursor: pointer;
                    position: relative;
                    top: 0;
                    transition: all 0.3s;
                    &:hover {
                        top: -4px;
                    }
                }
                &.yearCard {
                    .btn {
                        background: linear-gradient(116deg, #23BDFF 0%, #2383FF 100%);
                        box-shadow: inset 0px 0px 6px 0px rgba(171,240,255,0.8), 0px 4px 4px 0px rgba(0,0,0,0.25);
                    }
                }
                &.plusCard {
                    .btn {
                        background: linear-gradient(115deg, #C7C7C7 0%, #818FA1 100%);
                        box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25), inset 0px 4px 4px 0px #D9D9D9;
                    }
                }
            }
        }
        .memberIntroduce {
            .title {
                font-size: 28px;
                color: #333333;
                line-height: 34px;
                text-align: center;
                margin-bottom: 40px;
                font-weight: bold;
                margin-top: 42px;
            }
            .info {
                text-align: center;
                font-size: 18px;
                color: #333333;
                line-height: 24px;
                margin-bottom: 40px;
            }
            .introduceBox {
                display: flex;
                justify-content: space-between;
                margin-bottom: 40px;
                .introduceItem {
                    width: 285px;
                    height: 364px;
                    background: url('../../../common/images/memberDetails/introduce_item_bg.png') no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    padding-top: 40px;
                    box-sizing: border-box;
                    .introduceItemIcon {
                        width: 110px;
                        height: 110px;
                        margin: 0 auto 20px;
                    }
                    .itemIntro {
                        font-size: 20px;
                        color: #fff;
                        line-height: 38px;
                        margin-bottom: 37px;
                    }
                    .label {
                        font-size: 28px;
                        color: #FFFFFF;
                        line-height: 34px;
                    }
                }
            }
            .fourServe {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                position: relative;
                .serveItem {
                    width: 585px;
                    height: 90px;
                    padding: 16px 20px;
                    box-sizing: border-box;
                    background: #F5F5F5;
                    &:first-of-type {
                        margin-bottom: 30px;
                    }
                    &:nth-of-type(2) {
                        margin-bottom: 30px;
                    }
                    &:nth-of-type(2n) {
                        padding-left: 112px;
                    }
                    .itemTitle {
                        font-size: 18px;
                        color: #333333;
                        margin-bottom: 10px;
                        line-height: 24px;
                        font-weight: bold;
                    }
                    .itemContent {
                        font-size: 14px;
                        color: #333333;
                        line-height: 24px;
                    }
                }
                .fourIcon {
                    width: 212px;
                    height: 212px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    margin: auto;
                }
            }
        }
        .memberPower {
            margin-top: 42px;
            .tips {
                text-align: center;
                font-size: 18px;
                color: #333333;
                line-height: 22px;
                margin-bottom: 40px;
            }
            .typeTable {
                width: 945px;
                margin: 0 auto;
                .row {
                    display: flex;
                    height: 68px;
                    align-items: stretch;
                    .type {
                        width: 185px;
                        border: 1px solid #CADFEE;
                        background: #F3FAFF;
                        text-align: center;
                        line-height: 68px;
                        height: 68px;
                        font-size: 24px;
                        color: #333333;
                        box-sizing: border-box;
                    }
                    .yearCard {
                        width: 380px;
                        height: 68px;
                        text-align: center;
                        line-height: 68px;
                        font-size: 28px;
                        color: #fff;
                        font-weight: bold;
                        background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                    }
                    .plusCard {
                        width: 380px;
                        height: 68px;
                        text-align: center;
                        line-height: 68px;
                        font-size: 28px;
                        color: #FFE0AF;
                        font-weight: bold;
                        background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                    }
                    &.row2 {
                        height: 80px;
                        border-bottom: 2px solid #CADFEE;
                        .price {
                            width: 185px;
                            border-left: 1px solid #CADFEE;
                            border-top: none;
                            border-right: none;
                            background: #FFFFFF;
                            text-align: center;
                            line-height: 80px;
                            height: 80px;
                            font-size: 20px;
                            color: #333333;
                            box-sizing: border-box;
                        }
                        .yearprice {
                            width: 380px;
                            height: 80px;
                            text-align: center;
                            line-height: 80px;
                            font-size: 28px;
                            color: #FF6666;
                            border-left: 2px solid #1464C8;
                            border-right: 2px solid #1464C8;
                            box-sizing: border-box;
                            .unit {
                                font-size: 24px;
                            }
                        }
                        .plusprice {
                            width: 380px;
                            height: 80px;
                            text-align: center;
                            line-height: 80px;
                            font-size: 28px;
                            color: #FF6666;
                            border-right: 2px solid #434A55;
                            box-sizing: border-box;
                            .unit {
                                font-size: 24px;
                            }
                        }
                    }
                    &.row3 {
                        height: 616px;
                        .power {
                            width: 185px;
                            border-left: 1px solid #CADFEE;
                            border-bottom: 2px solid #CADFEE;
                            border-top: none;
                            border-right: none;
                            background: #FFFFFF;
                            text-align: center;
                            line-height: 616px;
                            height: 616px;
                            font-size: 20px;
                            color: #333333;
                            box-sizing: border-box;
                        }
                        .yearPower, .plusPower {
                            width: 380px;
                            height: 616px;
                            border: 2px solid #1464C8;
                            border-top: none;
                            box-sizing: border-box;
                            padding: 30px 36px;
                            display: flex;
                            flex-direction: column;
                            &.plusPower {
                                border: 2px solid #434A55;
                                border-left: none;
                                border-top: none;
                            }
                            .powerItemBox {
                                flex: 1;
                                height: 0;
                                .powerItem {
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 25px;
                                    &:last-of-type {
                                        margin-bottom: 36px;
                                    }
                                    .icon {
                                        width: 20px;
                                        height: 20px;
                                        margin-right: 15px;
                                    }
                                    .itemValue {
                                        font-size: 20px;
                                        color: #333333;
                                        line-height: 24px;
                                        font-weight: bold;
                                        span {
                                            color: #FF6666;
                                            font-weight: bold;
                                        }
                                    }
                                }
                            }
                            .btnBox {
                                height: 64px;
                                .btn {
                                    width: 270px;
                                    height: 54px;
                                    text-align: center;
                                    line-height: 54px;
                                    border-radius: 0 10px 0 10px;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    background: #FF6969;
                                    box-shadow: 0px 6px 8px 0px rgba(188,45,25,0.4);
                                    cursor: pointer;
                                    position: relative;
                                    top: 0px;
                                    margin: 0 auto;
                                    transition: all 0.3s;
                                    &:hover {
                                        background: #F95050;
                                        box-shadow: 0px 6px 12px 0px rgba(188,45,25,0.6);
                                        top: -4px;
                                    }
                                    &.disabled {
                                        background: #CCCCCC;
                                        box-shadow: 0px 6px 8px 0px rgba(180,180,180,0.4);
                                        &:hover {
                                            top: 0;
                                            cursor: default;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .questionItemBox {
            .questionItem {
                margin-top: 20px;
                width: 1000px;
                height: 115px;
                margin: 20px auto 0;
                box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);
                padding: 25px 40px;
                box-sizing: border-box;
                &:first-of-type {
                    margin-top: 40px;
                }
                .question {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;
                    .label {
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        font-size: 14px;
                        color: #ffffff;
                        background: #FF6666;
                        margin-right: 10px;
                    }
                    .value {
                        font-size: 18px;
                        color: #FF6666;
                        line-height: 22px;
                    }
                }
                .answer {
                    display: flex;
                    align-items: center;
                    .label {
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        font-size: 14px;
                        color: #ffffff;
                        background: #1464C8;
                        margin-right: 10px;
                    }
                    .value {
                        font-size: 18px;
                        color: #333333;
                        line-height: 22px;
                    }
                }
            }
        }
        .linkUs {
            width: 1000px;
            height: 202px;
            box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);
            padding: 25px;
            font-size: 18px;
            color: #333333;
            line-height: 38px;
            text-align: center;
            margin: 40px auto 0;
            box-sizing: border-box;
        }
        .memberPrivilege {
            padding-top: 40px;
            .titleMore {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                .title {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #333333;
                    &::before {
                        content: '';
                        width: 3px;
                        height: 18px;
                        background: #1464C8;
                        margin-right: 10px;
                    }
                }
                .more {
                    font-size: 14px;
                    color: #999999;
                    cursor: pointer;
                }
            }
            .itemBox {
                display: flex;
                align-items: center;
                .item {
                    width: 285px;
                    height: 200px;
                    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.15);
                    border-radius: 4px 4px 4px 4px;
                    overflow: hidden;
                    cursor: pointer;
                    &:hover {
                        box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.3);
                    }
                    &:not(:last-of-type) {
                        margin-right: 20px;
                    }
                    .coverurl {
                        width: 285px;
                        height: 160px;
                    }
                    .subject {
                        height: 40px;
                        padding: 0 12px;
                        box-sizing: border-box;
                        line-height: 40px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}
.openMemberSuccessDialog {
    .el-dialog {
        height: 482px;
        background: url('../../../common/images/memberDetails/open_member_success.png') no-repeat;
        background-size: 100% 100%;
        box-shadow: none;
        margin-top: 0 !important;
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            width: 100%;
            height: 100%;
            padding: 300px 0 0;
            box-sizing: border-box;
            .openSuccessTips {
                width: 480px;
                height: 320px;
                border-radius: 10px;
                margin: 0 auto;
                background: #fff;
                padding-top: 36px;
                box-sizing: border-box;
                .tips {
                    font-size: 28px;
                    color: #FF6666;
                    line-height: 48px;
                    margin-bottom: 10px;
                    text-align: center;
                    div {
                        font-weight: bold;
                    }
                }
                .expiredate {
                    font-size: 20px;
                    line-height: 52px;
                    color: #333333;
                    text-align: center;
                }
                .closeBtn {
                    width: 280px;
                    height: 52px;
                    border-radius: 100px;
                    margin: 32px auto 0;
                    background: #FCAE54;
                    text-align: center;
                    line-height: 52px;
                    font-size: 20px;
                    color: #fff;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>